import { isClickedOutside } from '@theme/utilities';

class DropdownGroupComponent extends HTMLElement {
  constructor() {
    super();

    this.dropdowns = [];
  }

  connectedCallback() {
    this.dropdowns = this.querySelectorAll('dropdown-component');

    document.addEventListener('click', this.#handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#handleDocumentClick);
  }

  #handleDocumentClick = (event) => {
    const clickedInsideDropdown = event.target.closest('dropdown-component');
    if (!clickedInsideDropdown) {
      this.closeAllDropdowns();
    }
  };

  closeAllDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.close();
    });
  }
}

if (!customElements.get('dropdown-group-component')) {
  customElements.define('dropdown-group-component', DropdownGroupComponent);
}

class DropdownComponent extends HTMLElement {
  constructor() {
    super();

    this.toggle = null;
    this.content = null;
    this.isOpen = false;
    this.hoverEnabled = false;
    this.closeTimer = null;
  }

  connectedCallback() {
    this.toggle = this.querySelector('[data-ref="dropdown-toggle"]');
    this.content = this.querySelector('[data-ref="dropdown-content"]');

    this.toggle?.addEventListener('click', this.#handleToggle);

    this.hoverEnabled =
      this.hasAttribute('data-kmega-hover') &&
      window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1001px)').matches;

    if (this.hoverEnabled) {
      this.addEventListener('pointerenter', this.#handlePointerEnter);
      this.addEventListener('pointerleave', this.#handlePointerLeave);
      this.addEventListener('keydown', this.#handleKeydown);
      this.addEventListener('focusout', this.#handleFocusOut);
    }
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.#handleToggle);

    if (this.hoverEnabled) {
      this.removeEventListener('pointerenter', this.#handlePointerEnter);
      this.removeEventListener('pointerleave', this.#handlePointerLeave);
      this.removeEventListener('keydown', this.#handleKeydown);
      this.removeEventListener('focusout', this.#handleFocusOut);
    }

    clearTimeout(this.closeTimer);
  }

  #handleToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (this.isOpen) {
      this.close();
    } else {
      this.closest('dropdown-group-component')?.closeAllDropdowns();
      this.open();
    }
  };

  #handlePointerEnter = () => {
    clearTimeout(this.closeTimer);
    if (this.isOpen) return;
    this.closest('dropdown-group-component')?.closeAllDropdowns();
    this.open();
  };

  #handlePointerLeave = () => {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), 140);
  };

  #handleKeydown = (event) => {
    if (event.key === 'Escape' && this.isOpen) {
      this.close();
      this.toggle?.focus();
    }
  };

  #handleFocusOut = (event) => {
    if (!this.contains(event.relatedTarget)) this.close();
  };

  #handleClickOutside = (event) => {
    if (isClickedOutside(event, this)) {
      this.close();
    }
  };

  open() {
    this.setAttribute('data-open', 'true');
    document.addEventListener('click', this.#handleClickOutside);
    this.isOpen = true;
  }

  close() {
    clearTimeout(this.closeTimer);
    this.setAttribute('data-open', 'false');
    document.removeEventListener('click', this.#handleClickOutside);
    this.isOpen = false;
  }
}

if (!customElements.get('dropdown-component')) {
  customElements.define('dropdown-component', DropdownComponent);
}
